/**
 * AI Genie Routes
 * legacy app: canActivate: [AuthGuard]
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const AiGenie = lazy(() =>
  import('@src/apps/AiGenie/AiGenie').then((m) => ({ default: m.AiGenie }))
);

export const aigenieRoutes: RouteConfig[] = [
  {
    path: 'pype-entity',
    component: AiGenie,
    guards: ['auth', 'provider'],
    data: {
      title: 'AI Genie',
      breadcrumb: 'AI Genie',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'pype-home',
    component: AiGenie,
    guards: ['auth', 'provider'],
    data: {
      title: 'AI Genie',
      breadcrumb: 'AI Genie Home',
      preload: false,
      delay: false,
    },
  },
];
